import { render, staticRenderFns } from "./OneRowLayout.vue?vue&type=template&id=736b2d1d&scoped=true&"
import script from "./OneRowLayout.vue?vue&type=script&lang=js&"
export * from "./OneRowLayout.vue?vue&type=script&lang=js&"
import style0 from "./OneRowLayout.vue?vue&type=style&index=0&id=736b2d1d&prod&scoped=true&lang=css&"
import style1 from "./OneRowLayout.vue?vue&type=style&index=1&id=736b2d1d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736b2d1d",
  null
  
)

export default component.exports